import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Question } from 'app/shared/models/question';
import { QuestionType } from 'app/shared/models/question-type';
import { ListQuestion } from 'app/shared/models/list-question';
import { QuestionSet } from 'app/shared/models/question-set';

@Component({
  selector: 'dac-question-list-item',
  templateUrl: './question-list-item.component.html',
  styleUrls: ['./question-list-item.component.scss']
})
export class QuestionListItemComponent implements OnInit {

  @Input() QuestionSet:QuestionSet;

  @Output() answered:EventEmitter<Question[]>;
  
  constructor() { 
    this.answered = new EventEmitter<Question[]>();
  }

  ngOnInit() {
  }

  get Questions() : Question[] {
    if (this.QuestionSet)
    {
      return this.QuestionSet.questions;
    }
    return [];
  }

  // TODO: stephen instead of all these cases would it be better just to dynamically create the components?
	isMultipleChoice(type:QuestionType) {
		return type == QuestionType.MultipleChoice;
	}
	isTextbox(type:QuestionType) {
		return type == QuestionType.Textbox;
	}

	isChecklist(type:QuestionType) {
		return type == QuestionType.Checklist;
	}
	isSingleChoice(type:QuestionType) {
		return type == QuestionType.SingleChoice;
  }
  
  getQuestionLabels(question:any) {
    if (question.CustomLabels && question.CustomLabels.length) {
      return question.CustomLabels
    }
    else if (this.QuestionSet.labels) {
      return this.QuestionSet.labels;
    }
    else {
      return [];
    }
  }
  
  handleAnswer(question:any) {
    console.log("Received answer for question: ", question);
    if (this.Questions.every(q => q.isFilledOut)){
      this.answered.emit(this.Questions);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/question-list-item/question-list-item.component.ts